// src/utils/index.ts

// Import utilities from their respective files with explicit naming
import * as apiUtils from './apiUtils';
import * as formatUtils from './formatUtils';
import * as validationUtils from './validationUtils';
import * as financialUtils from './financialUtils';

// Re-export utilities with explicit naming to avoid conflicts
export const {
  API_CONSTANTS,
  retryWithBackoff,
  extractErrorMessage
} = apiUtils;

export const {
  formatArrayForPostgres,
  cleanMetricValue,
  formatPercentage,
  formatDate
} = formatUtils;

export const {
  validateEmail,
  validatePassword,
  validateUrl
} = validationUtils;

// For the conflicting function, prefer the one from validationUtils
// and rename the one from financialUtils
export const {
  validateMetricValue
} = validationUtils;

export const {
  groupFinancialsByCategory,
  formatCurrency
} = financialUtils;

// Any shared constants can be defined here
export const APP_CONSTANTS = {
  APP_NAME: 'HotelValuAI',
  DEFAULT_PAGINATION_LIMIT: 10,
  SUPPORTED_FILE_TYPES: ['application/pdf', 'image/jpeg', 'image/png'],
  MAX_FILE_SIZE: 10 * 1024 * 1024, // 10MB
};

export * from './apiUtils';
export * from './formatUtils';
export * from './validationUtils';
export * from './financialUtils';
